import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Description } from '../../../Typography/index.js';
export const Disclaimer = ({ universityName }) => (_jsxs(Description, { style: {
        opacity: 0.75,
        maxWidth: 300,
        gridArea: 'disclaimers',
        marginTop: 25,
        textAlign: 'right',
        justifySelf: 'right'
    }, size: "small", element: "p", children: [`${universityName || 'University'} or AstrumU®`, " do not guarantee any particular job or salary upon graduation."] }));
//# sourceMappingURL=index.js.map